import React, { useState } from "react";
import Box from "@mui/material/Box";
import { useNavigate, useLocation } from "react-router-dom";
import { MuiOtpInput } from "mui-one-time-password-input";
import { useNotify } from "../../context/NotifyContext";
import { resetMpin } from "../../api/userAuth";
import AuthShell from "../../components/auth/AuthShell";
import {
  AuthField,
  authOtpFieldProps,
  authOtpSx,
} from "../../components/auth/AuthField";

const NewMpin = () => {
  const { notify } = useNotify();
  const navigate = useNavigate();
  const location = useLocation();

  const username =
    location.state?.username || sessionStorage.getItem("username");
  const resetToken =
    location.state?.resetToken || sessionStorage.getItem("resetToken");

  const [newMpin, setNewMpin] = useState("");
  const [confirmMpin, setConfirmMpin] = useState("");
  const [loading, setLoading] = useState(false);

  const handleResetMpin = async () => {
    if (!username) return notify("User not found", "error");
    if (!newMpin || !confirmMpin)
      return notify("MPIN & Confirm MPIN required", "warning");
    if (newMpin !== confirmMpin)
      return notify("MPIN does not match", "warning");
    if (!/^\d{6}$/.test(newMpin))
      return notify("MPIN must be 6 digits", "warning");
    if (!resetToken) return notify("Unauthorized action", "error");

    try {
      setLoading(true);

      const res = await resetMpin({
        mpin: newMpin,
        resetToken,
      });

      if (!res?.success)
        return notify(res?.message || "Reset failed", "error");

      notify("MPIN reset successfully", "success");

      sessionStorage.clear();
      navigate(`/verify/mpin/${username}`);
    } catch (err) {
      notify(err?.response?.data?.message || "Server error", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow="Secure access"
      title="Set New MPIN"
      subtitle="Create a 6-digit MPIN to unlock your dashboard."
      footer={
        <button type="button" className="ds-auth-link" onClick={() => navigate("/login")}>
          Back to Login
        </button>
      }
    >
      <Box className="flex flex-col gap-3.5">
        <AuthField label="Username">
          <input className="ds-input" value={username || ""} disabled />
        </AuthField>

        <AuthField label="New MPIN" required>
          <MuiOtpInput
            length={6}
            value={newMpin}
            onChange={setNewMpin}
            sx={authOtpSx}
            TextFieldsProps={authOtpFieldProps}
          />
        </AuthField>

        <AuthField label="Confirm New MPIN" required>
          <MuiOtpInput
            length={6}
            value={confirmMpin}
            onChange={setConfirmMpin}
            sx={authOtpSx}
            TextFieldsProps={authOtpFieldProps}
          />
        </AuthField>

        <button
          type="button"
          onClick={handleResetMpin}
          className="ds-btn ds-btn-primary ds-btn-block"
          disabled={loading}
        >
          {loading ? "Processing..." : "Reset MPIN"}
        </button>
      </Box>
    </AuthShell>
  );
};

export default NewMpin;
